module.exports = __webpack_public_path__ + "static/media/04.fcd172cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flight/volumetric/shoes/04.png
// module id = 641
// module chunks = 0